import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { SolarBaseComponent } from '@solar/solar/solar-base';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Site, InfoSite, Supervision } from 'solar-bo';;
import { AppConfig } from '@solar/app.config';
import { MessageError } from 'base-models';
import { AlertType } from 'base-models';
import { CountryPickerService, ICountry } from 'basecomponents';
import { DialogdeleteComponent } from 'basecomponents';
import { SortHelper } from 'shtools';
import { ErrorcontrolService } from 'basecomponents';
import { SiteEditDlgComponent } from '../site-edit/site-edit-dlg.component';
import { TableList } from 'shtools';
import { SiteListMapComponent } from '../site-list-map/site-list-map.component';
import { Table } from 'primeng/table';
import { SupervisEditDlgComponent } from '@solar/solar/supervis/supervis-edit/supervis-edit-dlg.component';



@Component({
  selector: 'app-site-list',
  templateUrl: './site-list.component.html',
  styleUrls: ['./site-list.component.scss']
})
export class SiteListComponent extends SolarBaseComponent implements OnInit, AfterViewInit {

  @Input() routeActive = true;
  @Output() siteSelectedEvent: EventEmitter<Site> = new EventEmitter();
  @Output() siteListFilteredEvent: EventEmitter<Site[]> = new EventEmitter();
  @ViewChild("sitelistmap") sitelistmap: SiteListMapComponent;
  @ViewChild("frtable") frtable: Table;
  tdata = new TableList<Site>();

  get listFiltered(): any[] {
    return this.tdata.filteredData;
  }
  //set filter(filter: string) { this._filter.next(filter); }

  public countries: ICountry[];

  constructor(private countryPickerService: CountryPickerService) {
    super();


  }

  ngOnInit() {
    //sites are cached by system so countries are returned later
    this.countryPickerService.getCountries().subscribe(countryList => {
      this.countries = CountryPickerService.sortCountries(countryList, "name.common");
      this.getList();
    });

  }

  ngAfterViewInit() {
    this.frtable.onFilter.subscribe(event => this.table_onfilter(event));
  }


  refresh() {
    this.getList();
  }

  uigetCountry(row: Site) {
    if (!row.info) {
      return "";
    }
    return CountryPickerService.uigetCountry(this.countries, row.info.country);
  }

  uigetCountryCC2(row: Site) {

    if (!row.info) {
      return "";
    }
    let countryFlag = CountryPickerService.uigetCountryObj(this.countries, row.info.country);
    if (countryFlag) {
      return countryFlag.cca2.toLowerCase();
    }

  }
  uigetZone(row: Site) {
    if (row.info && row.info.zone) {
      return row.info.zone;
    }
    return "";
  }


  getList(): void {
    this.listerrmessage = "";
    this.loading = true;

    /*     let filter = new FilterDTO();
        let filterbytypestring: any = (this.selectByStatus.getSelectBy() == null ? "-1" : this.selectByStatus.getSelectBy());
        filter.filteritems.push(new FilterParam("status", filterbytypestring));
    
        
        let filterbypropertystring: any = (this.filterbyproperty.getSelectBy() == null ? "-1" : this.filterbyproperty.getSelectBy());
        filter.filteritems.push(new FilterParam("propertyfilter", filterbypropertystring));
    
        let dtrange: DateRange = this.listdaterange.getDateRange();
        if (dtrange.dt_start != null) {
          filter.filteritems.push(new FilterParam("from", dtrange.getdtstart00String()));
        }
        if (dtrange.dt_end != null) {
          filter.filteritems.push(new FilterParam("to", dtrange.getdtend00String()));
        }
    
        filter.filteritems.push(new FilterParam("sortby", "modifydate desc")); */
    this.solarService.sitesGetByFilter(null)
      .subscribe(
        reslist => this.getListhandleresult(reslist)
        , err => this.getListhandleError(err)
      );
  }

  getListhandleresult(newlist: Site[]) {
    //console.log('getListhandleresult', newlist);
    this.listerrmessage = '';
    this.loading = false;
    //newlist=SortHelper.sortMultiple(newlist, ["name"]);
    let collator = new Intl.Collator();
    //newlist = newlist.sort((a, b) => new Intl.Collator().compare(a.name, b.name));

    newlist = newlist.sort((a, b) => this.sortByStringLocale(a.name, b.name));
    for (let x = 0; x < newlist.length; x++) {
      let item = Object.assign(new Site, newlist[x]);
      item.info = Object.assign(new InfoSite, item.info);
      item.info.countryFull2 = this.uigetCountry(item);
      newlist[x] = item;
    }
    //todo: hay que crear una tabla lisa para el resultado porque luego los filtros no funcionan con country por ejemplo
    this.tdata.data = newlist;
    this.alertmessage = null;
  }

    /**
     * Example:  let Sorted= arraySource.sort((a, b) => SortHelper.sortByString(a.name, b.name));
     * @param field1 
     * @param field2 
     */
  sortByString(field1, field2, isAsc: boolean=true) {
      return this.sortByStringLocale(field1, field2, isAsc);
  }
  sortByStringLocale(a, b, isAsc: boolean=true) {
    let res= new Intl.Collator().compare(a, b)* (isAsc ? 1 : -1);
    return res;
/*       let res=(this.sortByStringIntlCollator(a,b) ? 1 : -1) * (isAsc ? 1 : -1);
      console.log(res + "    " +a + " " + b)
      return res; */
  }

  sortByStringIntlCollator(a, b) {    
    let res=    new Intl.Collator('en').compare(a,b);
    console.log("Collator: " + res + "    " +a + " " + b);
      return res;
  } 



  getListhandleError<T>(err: any) {
    //console.log("getListhandleError");
    this.loading = false;
    this.alertmessage = ErrorcontrolService.basichandleError("", err);
  }

  showmessage(message: string) {
    this.alertmessage = new MessageError(AlertType.Success, message);
  }


  uiisdeletable(element: any) {
    return true;
  }

  openitem(item: Site) {
    if (this.routeActive) {
      this.router.navigateByUrl(AppConfig.ROUTE_SOLAR + "/site/" + item.id);
    } else {
      this.siteSelectedEvent.emit(item);
    }

    //this.router.navigate(['site/' , item.id],{relativeTo:this.route});
  }

  /**
  * New Site
  * @param itemToEdit 
  */
  newSite(itemToEdit?: Site) {
    let dialogRef: MatDialogRef<SiteEditDlgComponent>;
    dialogRef = SiteEditDlgComponent.openModal(this.dialog, itemToEdit);
    dialogRef.componentInstance.saveEvent.subscribe((site) => this.saveSiteEvent(dialogRef, itemToEdit, site));
  }

  saveSiteEvent(dialogRef: MatDialogRef<any>, siteToEdit: Site, site: Site) {
    super.saveSiteEvent(dialogRef, siteToEdit, site);

    const index = this.tdata.data.findIndex(d => d.id === site.id);
    if (index != -1) {
      this.tdata.update(index, site);
    } else {
      this.tdata.add(site);
    }

    if (siteToEdit == null) {

    }
    console.log("saveModelEvent list", site);
    /* if (dialogRef != null) {
      dialogRef.close();
    } */
  }

  openDialogDeleteSite(model: Site): any {

    let dialogRef = this.openDialogDelete("Delete Site", "Do you want to delete site: " + model.name, model);
    dialogRef.componentInstance.mainActionEmitter.subscribe(() => this.deletesiteHandler(model, dialogRef));
    return dialogRef;
  }

  deletesiteHandler(model: Site, dialogRef: MatDialogRef<DialogdeleteComponent>) {
    console.log("deletesiteHandler" + model.name);
    const dlgComp = dialogRef.componentInstance;
    dlgComp.lockdeletebtn();
    //dlgComp.addmessage("error","No se ha podido borrar el site");
    dialogRef.close();
    this.loadinglist = true;
    this.alertmessage = new MessageError(AlertType.Warning, "Deleting site, please wait");
    this.solarService.siteDelete(model.id).subscribe(
      () => this.siteDeleteSuccesshanler(model.id)
      , err => this.handleError(err, "Error deleting site: "));
  }
  siteDeleteSuccesshanler(id: string) {
    if (!this.tdata.data) {
      return;
    }
    const index = this.tdata.data.findIndex(el => el.id == id, 0);
    if (index > -1) {
      this.tdata.removebyindex(index);
    }
    this.loadinglist = false;
    this.alertmessage = new MessageError(AlertType.Success, "Site deleted");
  }

  /**
   * no usar aqui porque no sabe buscar por objetos
   * @param filterValue 
   */
  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.tdata.filterData(filterValue);
    this.siteListFilteredEvent.emit(this.tdata.filteredList);
    this.sitelistmap.siteList = this.tdata.filteredList;
  }

  tableFilter($event) {
    this.frtable.filterGlobal($event.target.value, 'contains');
    console.log(this.frtable);
    console.log(this.frtable.filteredValue);

    //this.sitelistmap.siteList=this.frtable.value;
  }

  table_onfilter($event) {
    let filter = $event;
    if (filter) {
      this.sitelistmap.siteList = filter.filteredValue;
    }

  }

  siteClickedEventHandler($event){
    let site=$event;
    this.openitem(site);
  }

  newsupervision(site?: Site) {
    let dialogRef: MatDialogRef<SupervisEditDlgComponent>;
    let supervis = new Supervision();
    supervis.site = site;
    dialogRef = SupervisEditDlgComponent.openModalWithModel(this.dialog, true, supervis);
    dialogRef.componentInstance.saveEvent.subscribe((resultModel) => this.saveSupervisionEvent(dialogRef, null, resultModel));

  }

  saveSupervisionEvent(dialogRef: MatDialogRef<any>, itemToEdit: Site, resultModel: Supervision) {
    dialogRef.close();
    this.globService.navigateTo('solar/supervision-master/' + resultModel.id);
  }

}
